import messages from './cms.json' with { type: 'json' };

export const cmsFi: Readonly<typeof messages> = messages;
